var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.855632 18C0.614168 18 0.38368 17.9012 0.230022 17.7256C0.0653877 17.55 -0.0114415 17.3085 0.0105097 17.0561L0.526363 12.6329C0.570266 12.3037 0.723924 12.0073 0.954412 11.7659L11.7873 0.932927C12.391 0.329268 13.1812 0 14.0264 0C14.8715 0 15.6727 0.329268 16.2654 0.932927L17.0556 1.72317C17.6593 2.32683 17.9995 3.13902 17.9886 3.98415C17.9886 4.82927 17.6483 5.61951 17.0556 6.21219L6.23368 17.0451C6.02514 17.2756 5.70685 17.4293 5.36661 17.4732C5.36661 17.4732 0.932461 17.989 0.921485 17.989H0.844656L0.855632 18ZM1.89831 16.0902L4.09344 15.8378L2.16173 13.9061L1.89831 16.0902ZM5.78368 15.0146L14.3776 6.42073L11.5788 3.62195L2.99588 12.2159L5.79466 15.0146H5.78368ZM15.6398 5.15854L15.8154 4.98293C16.0898 4.70854 16.2325 4.35732 16.2105 3.98415C16.2105 3.6 16.0678 3.24878 15.7934 2.98537L15.0032 2.19512C14.7508 1.93171 14.3886 1.77805 14.0154 1.77805C13.6422 1.77805 13.291 1.92073 13.0276 2.19512L12.852 2.37073L15.6508 5.16951L15.6398 5.15854Z",
    fill: "#9E9E9E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/Icon-Edit.8f795fa1.svg";
export { ForwardRef as ReactComponent };